// @flow
import React, { PureComponent } from 'react';
import { sendTags } from 'utils/tagManagerUtils';

export type DispatchProps = {
  displayModal: (modalObject: string, content: Object, force: boolean) => void
};

export type StateProps = {};

type Props = {} & DispatchProps;

class CentenaireSharePicture extends PureComponent<Props> {
  props: Props;

  handleButtonClicked = (e: MouseEvent) => {
    const { displayModal } = this.props;
    e.preventDefault();
    sendTags('page centenaire', 'clic cta contribuer', window.location.pathname);
    displayModal('MODAL_CENTENAIRE_FORM_EMAIL', {}, false);
  };

  render() {
    return (
      <a href="#" onClick={this.handleButtonClicked} className="btn btn--primary btn--gold">
        <span>Contribuer</span>
      </a>
    );
  }
}

export default CentenaireSharePicture;
